export interface MarketReportCommunicationRequest {
  address: string;
  subject: string;
  content: string;
}

export enum MarketReportCommunicationType {
  sms = 'SMS',
  email = 'Email',
}
